export default __webpack_public_path__ + "static/media/mainBanner.8fa82994.png";